"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _forEach2 = _interopRequireDefault(require("lodash/forEach"));
var _mapValues2 = _interopRequireDefault(require("lodash/mapValues"));
var _has2 = _interopRequireDefault(require("lodash/has"));
var CombinedMetaModel = /*#__PURE__*/
function () {
  // MetaModel interface
  function CombinedMetaModel() {
    (0, _classCallCheck2.default)(this, CombinedMetaModel);
    this.rules = {};
    this.labels = {};
    this.hints = {};
    this.files = {};
    this._knownMappings = new Map();
  }
  (0, _createClass2.default)(CombinedMetaModel, [{
    key: "_addField",
    value: function _addField(metaModel, targetFieldName, srcFieldName) {
      this.rules[targetFieldName] = metaModel.rules[srcFieldName];
      if ((0, _has2.default)(metaModel.labels, srcFieldName)) {
        this.labels[targetFieldName] = metaModel.labels[srcFieldName];
      }
      if ((0, _has2.default)(metaModel.hints, srcFieldName)) {
        this.hints[targetFieldName] = metaModel.hints[srcFieldName];
      }
      if ((0, _has2.default)(metaModel.files, srcFieldName)) {
        this.files[targetFieldName] = metaModel.files[srcFieldName];
      }
    }
  }, {
    key: "add",
    value: function add(metaModel, fieldMapping) {
      var _this = this;
      if (!fieldMapping) {
        var objectMap = {};
        this._knownMappings.set(metaModel, objectMap);
        (0, _forEach2.default)(metaModel.rules, function (value, fieldName) {
          objectMap[fieldName] = fieldName;
          _this._addField(metaModel, fieldName, fieldName);
        });
      } else if (Array.isArray(fieldMapping)) {
        var _objectMap = {};
        this._knownMappings.set(metaModel, _objectMap);
        (0, _forEach2.default)(fieldMapping, function (fieldName) {
          _objectMap[fieldName] = fieldName;
          _this._addField(metaModel, fieldName, fieldName);
        });
      } else {
        this._knownMappings.set(metaModel, fieldMapping);
        (0, _forEach2.default)(fieldMapping, function (targetFieldName, srcFieldName) {
          return _this._addField(metaModel, targetFieldName, srcFieldName);
        });
      }
    }
  }, {
    key: "pickValuesBy",
    value: function pickValuesBy(metaModel, values) {
      var fieldMapping = this._knownMappings.get(metaModel);
      return (0, _mapValues2.default)(fieldMapping, function (targetFieldName) {
        return values[targetFieldName];
      });
    }
  }]);
  return CombinedMetaModel;
}();
exports.default = CombinedMetaModel;